import { Link } from 'react-router-dom';
import menuPhotos from '../assets/menuImages';
import { naturalJuices } from '../data/menuData';
import OptimizedImage from './OptimizedImage';
import { LeafIcon, HeartIcon } from './Icons';

const commitments = [
  { icon: LeafIcon, title: '100% Fruits', desc: 'Sélectionnés avec soin' },
  { icon: HeartIcon, title: 'Fait maison', desc: 'Avec amour et passion' },
];

function NaturalJuicesSection() {
  return (
    <section className="natural-juices" aria-label="Jus naturels DoWhile Food">
      <div className="natural-juices-inner">
        <div className="natural-juices-visual">
          <OptimizedImage
            image={menuPhotos.jusNaturels}
            alt="Jus naturels DoWhile Food — Mangue, Baobab et Bissap, 100% naturel"
            className="natural-juices-banner"
            loading="lazy"
          />
        </div>

        <div className="natural-juices-content">
          <p className="natural-juices-tag">Jus naturels</p>
          <h2 className="natural-juices-title">
            Le goût authentique des fruits,<br />
            <span>la fraîcheur à chaque gorgée !</span>
          </h2>
          <p className="natural-juices-lead">
            100% naturel, sans conservateur, sans colorant. Nos jus sont pressés à froid
            pour préserver le goût et les vitamines de chaque fruit.
          </p>

          <ul className="natural-juices-flavors">
            {naturalJuices.map((juice) => (
              <li key={juice.id} className="natural-juices-flavor">
                {juice.name.replace('Jus de ', '')}
              </li>
            ))}
          </ul>

          <div className="natural-juices-commitments">
            {commitments.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="natural-juices-commitment">
                <div className="natural-juices-commitment-icon">
                  <Icon size={18} />
                </div>
                <div>
                  <p className="natural-juices-commitment-title">{title}</p>
                  <p className="natural-juices-commitment-desc">{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="natural-juices-footnote">
            Du goût, du plaisir, du naturel — à déguster à tout moment !
          </p>

          <Link to="/menu?category=boissons" className="btn btn-primary natural-juices-cta">
            Voir nos boissons
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NaturalJuicesSection;
